var map = {
	"./__tests__/lti.resourceImported.test.js": [
		"LFe7",
		4137
	],
	"./__tests__/lti.screenReaderAlert.test.js": [
		"0Guc",
		4138
	],
	"./__tests__/lti.showAlert.test.js": [
		"+y7l",
		4139
	],
	"./__tests__/requestFullWindowLaunch.test.js": [
		"o6ta",
		4140
	],
	"./lti.enableScrollEvents.js": [
		"HVU3",
		4202
	],
	"./lti.fetchWindowSize.js": [
		"OANa",
		4203
	],
	"./lti.frameResize.js": [
		"bSyB",
		4131
	],
	"./lti.removeUnloadMessage.js": [
		"tjuu",
		4141
	],
	"./lti.resourceImported.js": [
		"FC2N",
		4204
	],
	"./lti.screenReaderAlert.js": [
		"YYEg",
		4205
	],
	"./lti.scrollToTop.js": [
		"W/R1",
		4206
	],
	"./lti.setUnloadMessage.js": [
		"6fDN",
		4142
	],
	"./lti.showAlert.js": [
		"onLg",
		4207
	],
	"./lti.showModuleNavigation.js": [
		"NSTA",
		4208
	],
	"./org.imsglobal.lti.capabilities.js": [
		"zPPZ",
		4209
	],
	"./requestFullWindowLaunch.js": [
		"8IHO",
		4210
	],
	"./toggleCourseNavigationMenu.js": [
		"ECMy",
		3656,
		4211
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "G4i8";
module.exports = webpackAsyncContext;